// @flow
import type { Reducer } from 'redux';

type ActionWithReducerMap<S, K, T> = { [key: K]: Reducer<S, T> | Array<Reducer<S, T>> };

export function createReducer<S, K: *, T: *>(
  initialState: S,
  handlers: ActionWithReducerMap<S, K, T>,
): Reducer<S, T> {
  return function reducer(state?: S = initialState, action: T): S {
    if (Object.prototype.hasOwnProperty.call(handlers, action.type)) {
      const handler = handlers[action.type];

      if (handler instanceof Array) {
        return handler.reduce((acc, i) => i(acc, action), state);
      }

      return handler(state, action);
    }

    return state;
  };
}

export default createReducer;



// WEBPACK FOOTER //
// ./src/store/helpers/createReducer.js